import { graphql } from '@repo/common/queries/schemas/server_user_query'

export const query_get_version = graphql(`
  query get_version {
    version
    app_env
  }
`)
